export const styles = {
  accordionRow: {
    borderRadius: 1,

    '.MuiGrid-container': {
      mt: 0,
      pt: 0.75,
      pb: 0.75,
      '.MuiGrid-item': {
        pt: 0.5,
        pb: 0.5,
        display: 'flex',
        alignItems: 'center',
      },
    },

    '&.Mui-expanded': {
      margin: '0 auto',
    },
    '&:before': {
      display: 'none',
    },

    '.MuiCollapse-root': {
      pl: 2.5,
      pr: 2.5,
    },

    '.MuiAccordionDetails-root': ({ palette }) => ({
      pt: 2,
      pb: 0.75,
      pl: 0,
      pr: 0,
      ml: 3,
      mr: 1,
      borderTop: `1px solid ${palette.grey.L60}`,
    }),
    '.MuiButton-outlinedPrimary': ({ palette }) => ({
      background: palette.common.white,
    }),
  },
  accordionSummary: ({ palette }) => ({
    height: 'auto',
    mr: 1,
    '&.MuiAccordionSummary-root': {
      alignItems: 'flex-start',
      gap: 0.5,
    },

    '.MuiAccordionSummary-content.Mui-expanded': {
      margin: '12px 0',
    },
    '.MuiAccordionSummary-expandIconWrapper': {
      color: palette.naval.L40,
      mt: 3,
    },
  }),
  accordionFooter: {
    '&.MuiAccordionDetails-root': {
      display: 'flex',
      pl: 0,
      pr: 0,
      pt: 2,
      pb: 3,
      mr: 0.5,
      gap: 2,
      button: {
        flex: 'auto',
        width: '50%',
      },
    },
  },
  actionButton: {
    height: 32,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
};
